class StudyQueryKeys {
    prefix = 'study';
    getStudy(studyId) {
        return [this.prefix, studyId];
    }
}
export default StudyQueryKeys;
